import clsx from 'clsx';
import { Trans, useTranslation } from 'next-i18next/pages';
import Image, { StaticImageData } from 'next/image';
import React, { ReactNode } from 'react';

export type EmptyListComponentVariant =
  | 'noFilters'
  | 'noRequiredFilters'
  | 'noPositionFilter'
  | 'noLocationFilter'
  | 'noResults'
  | 'noResultsContactJobDetective'
  | 'noResultsSuggestionsModal';

export const EmptyListComponentBase: React.FC<{
  variant: EmptyListComponentVariant;
  smallScreenImage: StaticImageData;
  largeScreenImage: StaticImageData;
  smallScreenImageClassName?: string;
  largeScreenImageClassName?: string;
  smallScreenImageWidth?: number;
  children?: ReactNode;
  className?: string;
}> = ({
  variant = 'noFilters',
  children,
  smallScreenImage,
  largeScreenImage,
  smallScreenImageClassName,
  largeScreenImageClassName,
  smallScreenImageWidth = 380,
  className,
}) => {
  const { t } = useTranslation('jobBoard', { keyPrefix: 'emptyList' });

  const defaultChildren = (
    <p className='whitespace-normal text-center text-lg font-semibold sm:whitespace-pre-wrap lg:text-left'>
      <Trans components={{ span: <span className='text-primary' /> }} i18nKey={variant} t={t} />
    </p>
  );

  return (
    <div
      data-testid='empty-list-component'
      className={clsx('container mx-auto my-10 flex flex-col items-center justify-center gap-8 lg:flex-row lg:gap-3', className)}>
      <div className={clsx('relative w-80 min-w-[360px] sm:w-[373px] md:hidden', smallScreenImageClassName)}>
        <Image alt='' className='object-cover' width={smallScreenImageWidth} src={smallScreenImage} />
      </div>
      <div className={clsx('relative hidden h-[435px] w-80 min-w-[360px] sm:h-[456px] md:block', largeScreenImageClassName)}>
        <Image alt='' className='object-cover' src={largeScreenImage} />
      </div>
      {children || defaultChildren}
    </div>
  );
};

export default EmptyListComponentBase;
